export const sortAlphabeticallyByAProperty = (array: Array<any>, propertyName = 'name'): void => {
  array.sort((a: any, b: any): number => {
    const nameA = a[propertyName]?.toUpperCase()
    const nameB = b[propertyName]?.toUpperCase()
    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0
  })
}

export const sortByNumericProperty = (
  array: Array<any>,
  propertyName = 'created',
  sortDir = 'desc',
): Array<any> => {
  const arr = [...array]
  if (sortDir === 'asc') {
    return arr.sort((a: any, b: any) => a[propertyName] - b[propertyName])
  }
  return arr.sort((a: any, b: any) => b[propertyName] - a[propertyName])
}
